import { useTheme } from '@mui/material'
import React from 'react'
import { HqOverdueIcon } from 'src/designSystem/icons'
import IndicatorTooltip from './IndicatorTooltip'

const HqOverdueIndicator = () => {
  const { palette } = useTheme()

  return (
    <IndicatorTooltip title="HQ Overdue">
      <span data-testid="hq-overdue-indicator">
        <HqOverdueIcon color={palette.darkestGreen} />
      </span>
    </IndicatorTooltip>
  )
}

export default HqOverdueIndicator
